import { useCallback } from 'react'
import styled from '@emotion/styled'
import { useFormDispatch, useFormSelector } from '../../../redux/formStoreHooks'
import Loading from '../../Loading'
import { L1ReasonableButton } from '../l1/L1Button'
import { faSave } from '@fortawesome/pro-solid-svg-icons'
import L2Surface from '../l2/L2Surface'
import { ImportWriteMode } from '@fusion-advantage/backcompat'
import { formDefaultSubmitTo, proposeFormSaveDraft } from '@fusion-advantage/formlib'
import { selectExport } from '../../../redux/selectForm'
import { submitForm } from '../../../lib/persistence/submitForm'

const Centered = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
})

const L4FormSubmitButton = () => {
	const importLoading = useFormSelector(state => state.render.importLoading)
	const writeMode = useFormSelector(state => state.render.form?.writeMode ?? ImportWriteMode.ReadOnly)
	const codeNext = useFormSelector(state => selectExport(state)?.Form.Encounter.CodeNext)
	const previewMode = useFormSelector(state => state.render.previewMode)
	const dispatch = useFormDispatch()
	const canSaveDraft = codeNext && proposeFormSaveDraft(writeMode, codeNext).isOk()
	const nextCodeNext = codeNext ? formDefaultSubmitTo(codeNext) : null
	const handleClick = useCallback(() => {
		if(previewMode) {
			alert('[L4FormSubmitButton] Cannot submit during preview mode')
			return
		}
		if(!nextCodeNext) {
			alert('[L4FormSubmitButton] codeNext is unavailable')
			return
		}
		dispatch(submitForm({codeNext: nextCodeNext}))
	}, [dispatch, nextCodeNext])
	if(!canSaveDraft || !nextCodeNext) {
		return null
	}
	return (
		<L2Surface>
			<Centered>
				{importLoading ? (
					<Loading size="2x" />
				) : (
					<L1ReasonableButton
						icon={faSave}
						label="Submit Form"
						onClick={handleClick}
					/>
				)}
			</Centered>
		</L2Surface>
	)
}

export default L4FormSubmitButton
